import { isEqual } from 'lodash-es';
import { type PropsWithChildren, useEffect, useState } from 'react';

import { DATEPICKER_MODE } from './constant';
import VDatePickerContext from './context';
import type { VDatePickerContextValue, VDatePickerProps } from './type';
import { toDateOrDateArray, toStringOrStringArray } from './util';

export const VDatePickerContextProvider = <
  M extends DATEPICKER_MODE | Lowercase<DATEPICKER_MODE>,
>({
  children,
  mode = DATEPICKER_MODE.SINGLE as any,
  value: _value,
  onChange,
}: PropsWithChildren<
  Pick<VDatePickerProps<M>, 'mode' | 'value' | 'onChange'>
>) => {
  const [value, setValue] = useState<string | string[]>(
    toStringOrStringArray(_value as any),
  );
  const isRangePicker = Array.isArray(_value);

  useEffect(() => {
    const __value = _value ?? (mode === DATEPICKER_MODE.RANGE ? [] : '');

    if (isEqual(value, toStringOrStringArray(__value))) return;

    setValue(toStringOrStringArray(__value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRangePicker, _value]);

  useEffect(() => {
    const __value = _value ?? (mode === DATEPICKER_MODE.RANGE ? [] : '');

    if (isEqual(value, toStringOrStringArray(__value))) return;

    const newValue = toDateOrDateArray(value);

    onChange?.(newValue as any);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <VDatePickerContext.Provider<VDatePickerContextValue<M>>
      value={{
        mode,
        value: value as VDatePickerContextValue<M>['value'],
        onChange: setValue,
      }}
    >
      {children}
    </VDatePickerContext.Provider>
  );
};
